import { render, staticRenderFns } from "./AllTestReports.vue?vue&type=template&id=3203ab14"
import script from "./AllTestReports.vue?vue&type=script&lang=js"
export * from "./AllTestReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports